module.exports = __webpack_public_path__ + "static/img/yd.88612b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yd.jpg
// module id = 0P/3
// module chunks = 1